import React from 'react';

import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';

import { FormInput, Button } from 'modules/common/input';
// import { toastError } from 'modules/common/toast';
// import { getFirstMessage } from 'modules/common/utils';

import { resetPasswordSchema } from '../validation';
import { usePostResetPassword } from '../hooks';

const INIT_FORM = {
  password: '',
  password_confirmation: '',
};

function ResetPasswordForm({ token, setTokenExpired }) {
  const history = useHistory();
  const [validation, setValidation] = React.useState(false);
  const [isApiLoading, post] = usePostResetPassword();

  const { values, errors, submitForm, setFieldValue } = useFormik({
    initialValues: INIT_FORM,
    validationSchema: resetPasswordSchema,
    validateOnChange: validation,
    validateOnBlur: validation,
    onSubmit: (payload) => {
      post(
        payload,
        token,
        () => history.push('/merchant-login'),
        (err) => {
          const { response } = err || {};

          if (response?.error === 'otp_expired') {
            setTokenExpired(true);

            setTimeout(() => {
              history.push('/forgot-password');
            }, 4000);
          }
        }
      );
    },
  });

  return (
    <form noValidate>
      <div className="space-y-5">
        <FormInput
          name="password"
          label="Password"
          icon={false}
          value={values?.password || ''}
          error={errors?.password || errors?.password_passed}
          onSetFieldValue={setFieldValue}
          type="password"
          required
          withStrengthValidation
          withShowPassword
        />
        <FormInput
          name="password_confirmation"
          label="Confirm Password"
          icon={false}
          value={values?.password_confirmation || ''}
          error={errors?.password_confirmation}
          onSetFieldValue={setFieldValue}
          type="password"
          required
          withShowPassword
        />

        <div className="space-y-3 text-center">
          <Button
            disabled={isApiLoading}
            className="btn primary md w-full mb-3"
            label="Save"
            onClick={() => {
              submitForm();
              setValidation(true);
            }}
          />

          <Button
            to="/merchant-login"
            className="w-full text-center text-sm font-medium text-black my-3 hover:underline"
            label="Go back to merchant login"
          />
        </div>
      </div>
    </form>
  );
}

ResetPasswordForm.defaultProps = {
  token: '',
  setTokenExpired: () => {},
};

ResetPasswordForm.propTypes = {
  token: PropTypes.string,
  setTokenExpired: PropTypes.instanceOf(Function),
};

export default ResetPasswordForm;
